// Per-article head: title (front-matter metaTitle if set, else the H1
// title), description, canonical, OG/Twitter image (the
// generated OG card), article times, RSS link, and noindex for
// drafts or articles marked noindex.
export default function documentProps(pageContext) {
  const a = pageContext.data?.article;
  if (!a) return {};
  return {
    title: `${a.metaTitle || a.title} | Gabsor`,
    description: a.description,
    url: `https://gabsor.com${a.url}`,
    image: `https://gabsor.com${a.cards.og}`,
    ogType: 'article',
    publishedTime: a.published || undefined,
    modifiedTime: a.updated,
    rss: true,
    robots: a.robotsNoindex ? 'noindex' : undefined,
  };
}
